/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Courts_YetInputs */

const th_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยังไม่ได้กำหนดสนามสำหรับรายการนี้`)
};

const en_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No courts assigned for this event yet.`)
};

const ja_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この大会のコートはまだ割り当てられていません。`)
};

const zh_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未为此赛事分配球场。`)
};

const es_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todavía no hay pistas asignadas a este evento.`)
};

const pt_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma quadra definida para este evento ainda.`)
};

const id_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada lapangan yang ditetapkan untuk acara ini.`)
};

const fr_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun terrain attribué à cet événement pour l’instant.`)
};

const tl_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala pang court na naitalaga para sa event na ito.`)
};

const vi_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa phân sân nào cho sự kiện này.`)
};

const ko_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 이벤트에 배정된 코트가 아직 없습니다.`)
};

const de_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für dieses Event sind noch keine Felder zugewiesen.`)
};

const ru_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для этого события площадки ещё не назначены.`)
};

const tr_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu etkinlik için henüz saha atanmadı.`)
};

const it_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun campo ancora assegnato a questo evento.`)
};

const pl_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie przypisano jeszcze boisk do tego wydarzenia.`)
};

const uk_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для цієї події майданчиків ще не призначено.`)
};

const hi_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस आयोजन के लिए अभी कोई कोर्ट तय नहीं है।`)
};

const ar_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم تُحدَّد ملاعب لهذه الفعالية بعد.`)
};

const ms_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada gelanggang ditetapkan untuk acara ini.`)
};

const bn_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই আয়োজনের জন্য এখনও কোর্ট নির্ধারিত হয়নি।`)
};

const zh_tw2_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未為本賽事指派球場。`)
};

const zh_hk2_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尚未為本賽事指派球場。`)
};

const ur_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس ایونٹ کے لیے ابھی کورٹ مقرر نہیں ہوئے۔`)
};

const fa_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هنوز زمینی برای این رویداد تعیین نشده.`)
};

const sw_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna viwanja vilivyopangwa kwa tukio hili bado.`)
};

const nl_no_courts_yet = /** @type {(inputs: No_Courts_YetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen velden toegewezen aan dit evenement.`)
};

/**
* | output |
* | --- |
* | "No courts assigned for this event yet." |
*
* @param {No_Courts_YetInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_courts_yet = /** @type {((inputs?: No_Courts_YetInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Courts_YetInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_no_courts_yet(inputs)
	if (locale === "ja") return ja_no_courts_yet(inputs)
	if (locale === "zh") return zh_no_courts_yet(inputs)
	if (locale === "es") return es_no_courts_yet(inputs)
	if (locale === "pt") return pt_no_courts_yet(inputs)
	if (locale === "id") return id_no_courts_yet(inputs)
	if (locale === "fr") return fr_no_courts_yet(inputs)
	if (locale === "tl") return tl_no_courts_yet(inputs)
	if (locale === "vi") return vi_no_courts_yet(inputs)
	if (locale === "ko") return ko_no_courts_yet(inputs)
	if (locale === "de") return de_no_courts_yet(inputs)
	if (locale === "ru") return ru_no_courts_yet(inputs)
	if (locale === "tr") return tr_no_courts_yet(inputs)
	if (locale === "it") return it_no_courts_yet(inputs)
	if (locale === "pl") return pl_no_courts_yet(inputs)
	if (locale === "uk") return uk_no_courts_yet(inputs)
	if (locale === "hi") return hi_no_courts_yet(inputs)
	if (locale === "ar") return ar_no_courts_yet(inputs)
	if (locale === "ms") return ms_no_courts_yet(inputs)
	if (locale === "bn") return bn_no_courts_yet(inputs)
	if (locale === "zh-TW") return zh_tw2_no_courts_yet(inputs)
	if (locale === "zh-HK") return zh_hk2_no_courts_yet(inputs)
	if (locale === "ur") return ur_no_courts_yet(inputs)
	if (locale === "fa") return fa_no_courts_yet(inputs)
	if (locale === "sw") return sw_no_courts_yet(inputs)
	if (locale === "nl") return nl_no_courts_yet(inputs)
	return en_no_courts_yet(inputs)
});